/* Keep gift choices in the cart. Dismiss Koala's automatic picker through its
 * own close button so its pending promise and scroll lock are released. */
(() => {
  'use strict';
  const popupId = 'koala-gifts-popup-root';
  const watched = new WeakSet();

  function dismiss(popup) {
    if (!popup || watched.has(popup)) return;
    watched.add(popup);
    // Hide only while the app finishes rendering its close button. If its
    // markup changes, fail open rather than leaving an invisible modal.
    const previousVisibility = popup.style.visibility;
    popup.style.visibility = 'hidden';
    let timer;
    const restore = () => {
      observer.disconnect();
      clearTimeout(timer);
      popup.style.visibility = previousVisibility;
    };
    const close = () => {
      const button = Array.from(popup.querySelectorAll('button'))
        .find(element => element.textContent.trim() === '✕');
      if (!button) return;
      observer.disconnect();
      clearTimeout(timer);
      button.click();
      // Normal close removes the root and releases the app's body scroll lock.
      if (popup.isConnected) popup.style.visibility = previousVisibility;
    };
    const observer = new MutationObserver(close);
    observer.observe(popup, {childList: true, subtree: true});
    timer = setTimeout(restore, 1500);
    close();
  }

  function start() {
    dismiss(document.getElementById(popupId));
    const observer = new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1 && node.id === popupId) dismiss(node);
        }
      }
    });
    // Koala appends its native popup directly to body. Avoid observing every
    // cart/gallery mutation, and leave our cart dialog and Candy Rack alone.
    observer.observe(document.body, {childList: true});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once: true});
  } else {
    start();
  }
})();
